import React, { useEffect, useState } from 'react'
import { AssetMap, Round, TimestampedTeamRoundPlayerScoreMap } from "../types"
import calculateScores from "../scoreCalculator"
import TeamLeaderboard from "./TeamLeaderboard"
import IndividualLeaderboard from "./IndividualLeaderboard"

interface LeaderboardScreenProps {
  round: Round,
  scores: TimestampedTeamRoundPlayerScoreMap,
  assets: AssetMap
}

export default function LeaderboardScreen(props: LeaderboardScreenProps) {

  const { round, assets } = props
  const [ timestampedScores, setTimestampedScores ] = useState(props.scores)
  const { scores, lastUpdated } = timestampedScores
  const { teamRounds, skins } = calculateScores(round, scores)

  const updateTimestampedScores = (scores) => {
    if(scores.lastUpdated > lastUpdated) {
      setTimestampedScores(scores)
    } else {
      console.log(`Ignored scores with timestamp ${scores.lastUpdated} because latest scores are from ${lastUpdated}`)
    }
  }

  useEffect(() => {
    if(assets.pusherKey) {
      // @ts-ignore
      const pusher = new Pusher(assets.pusherKey, { cluster: "mt1" })

      const channel = pusher.subscribe(`round-${round.id}-scores`)
      channel.bind("update", updateTimestampedScores)
      console.log("connected to pusher")
    } else {
      console.warn("pusherKey not set, no pusher updated will be received")
    }
  }, [])

  return (
    <React.StrictMode>
      <section className="heading">
        <h1>{round.league.name}</h1>
        <p>
          {round.course.name}, {round.course.city}, {round.course.state}
          <br />
          {round.startDay} at {round.startTimeOfDay}
        </p>
      </section>

      <h2>Teams</h2>
      <TeamLeaderboard round={round} teamRounds={teamRounds} />

      <h2>Individuals</h2>
      <IndividualLeaderboard round={round} teamRounds={teamRounds} />
    </React.StrictMode>
  )
}
